import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for L316 (稽核改善進度管制)
// ============================================================

export interface FilterParams {
  startNo?: string;   // FL160_01 通知單號起始 (max 7 chars)
  lastNo?: string;    // FL160_01 通知單號結束 (max 7 chars)
}

export interface ResultRow {
  // FL160 columns
  fl160_01: string;           // 通知單號
  fl160_11: string;           // 查檢表單號(前5碼)
  fl160_111: number;          // 查核明細序號
  fl160_12: string | null;    // 通知日期
  fl160_13: string;           // 改善說明
  fl160_14: string;           // 受通知人
  fl160_15: boolean;          // 完成旗標
  fl160_16: boolean;          // 確認旗標
  fl160_21: string;           // 改善對策
  fl160_22: string | null;    // 改善完成日
  fl160_23: string;           // 改善負責人
  fl160_24: string;           // 確認人員
  fl160_25: string | null;    // 確認日期
  fl160_31: number;           // 追蹤次數
  fl160_32: string | null;    // 追蹤日期
  fl160_33: string;           // 追蹤人員
  fl160_34: string;           // 追蹤說明
  fl160_35: number;           // 追蹤結果
  fl160_80: string;           // 異動狀態
  fl160_91: string;           // 建立人員
  fl160_92: string | null;    // 建立日期
  fl160_93: string;           // 備用

  // FL150 columns
  fl150_01: string;           // 查檢表單號
  fl150_10: number;           // 稽核次數
  fl150_11: string | null;    // 稽核日期
  fl150_12: string;           // 稽核部門
  fl150_13: string;           // 稽核員
  fl150_14: string;           // 陪同人員

  // FL151 columns
  fl151_01: string;           // 查檢表單號
  fl151_02: number;           // 項次
  fl151_03: string;           // 條文代碼
  fl151_03a: string;          // 條文代碼A
  fl151_04: string;           // 類別
  fl151_04a: string;          // 類別A
  fl151_11: string;           // 查核人員
  fl151_12: string;           // 查核說明
  fl151_21: string;           // 判定
  fl151_22: string;           // 判定說明
  fl151_23: string;           // 通知單號

  // Lookup display names
  notified_person_name: string;
  notified_person_dept: string;
  auditor_name: string;
  improver_name: string;
  confirmer_name: string;
  tracker_name: string;
}

export interface ReportResponse {
  items: ResultRow[];
  total: number;
}

// ============================================================
// API methods
// ============================================================

export const l316Api = {
  /** Query audit improvement progress records with optional range filters */
  async getReport(params: FilterParams): Promise<ReportResponse> {
    const query: Record<string, string> = {};
    if (params.startNo?.trim()) query['startNo'] = params.startNo.trim();
    if (params.lastNo?.trim()) query['lastNo'] = params.lastNo.trim();
    const res = await apiClient.get('/api/l316/report', { params: query });
    return res.data;
  },
};
